import { render, staticRenderFns } from "./CopyrightAmendmentAttachments.vue?vue&type=template&id=767b876c&scoped=true&"
import script from "./CopyrightAmendmentAttachments.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentAttachments.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentAttachments.vue?vue&type=style&index=0&id=767b876c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767b876c",
  null
  
)

export default component.exports